<script>
  import { file2base64 } from "./utils.js";

  export let schema;
  export let id;
  export let value;
  export let error = false;

  let image;
  let imageObj;

  $: value, setImg();

  const setImg = async () => {
    if (value) {
      if (typeof value !== 'string') {
        image = await file2base64(value);
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(value);
        imageObj.files = dataTransfer.files;
      }
    } else image = value;
  }
  const imageSet = async () => { if (value !== imageObj.files[0])  value = imageObj.files[0]; }
  const dropImage = async e => { if (value !== e.dataTransfer.files[0]) value = e.dataTransfer.files[0] }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<figure id="{ id }_image" class:has-error={ error } on:click={ () => { imageObj.click() } } on:drop|preventDefault={ dropImage } on:dragover|preventDefault>
  {#if typeof value === 'string'}
    <img src="https://placehold.jp/cccccc/787878/650x650.png?text=Loading..." alt="Loading..." title="Loading...">
  {:else}
    {#if image}
      <img src={ image } alt="Drop your file or click to select" title="Drop your image or click to select">
    {:else}
      <img src="https://placehold.jp/cccccc/787878/650x650.png?text=Drop or Click" alt="Drop your file or click to select" title="Drop your image or click to select">
    {/if}
    <input { id } type="file" accept="image/*" bind:this={ imageObj } on:change={ imageSet } style="visibility: hidden;">
  {/if}
</figure>
